<template>
    <div class="ah-el-year-picker">
        <div class="picker-inner">
            <el-date-picker
                ref="pickerFirst"
                class="picker-first"
                v-model="formData.yearStart"
                value-format="timestamp"
                type="year"
                size="small"
                prefix-icon="-"
                :picker-options="{ disabledDate: disabledDateStart }"
                :clearable="false"
                @change="onDateChange('First', $event)"
            >
            </el-date-picker>
            <div class="line">~</div>
            <el-date-picker
                ref="pickerSecond"
                class="picker-second"
                v-model="formData.yearEnd"
                value-format="timestamp"
                type="year"
                size="small"
                prefix-icon="-"
                :picker-options="{ disabledDate: disabledDateEnd }"
                :clearable="false"
                @change="onDateChange('Second', $event)"
                @blur="onBlur"
            >
            </el-date-picker>
        </div>
    </div>
</template>

<script>
import { head, last } from 'lodash';
import moment from 'moment';

export default {
    name: 'ahElYearPicker',
    data() {
        return {
            formData: {
                yearStart: '',
                yearEnd: '',
            },
        };
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    mounted() {
        this.formData.yearStart = head(this.value);
        this.formData.yearEnd = last(this.value);
    },
    methods: {
        disabledDateStart() {
            return false;
            // if (!this.formData.yearEnd) return false;
            // return moment(date).year() > Number(this.formData.yearEnd);
        },
        disabledDateEnd(date) {
            if (!this.formData.yearStart) return false;
            return moment(date).year() < moment(this.formData.yearStart).year();
        },
        onDateChange(dom) {
            if (Number(this.formData.yearStart) > Number(this.formData.yearEnd)) this.formData.yearEnd = '';

            if (dom === 'First' && !this.formData.yearEnd) {
                this.$refs.pickerSecond.focus();
            } else if (dom === 'Second' && !this.formData.yearStart) {
                this.$refs.pickerFirst.focus();
            }

            if (!this.formData.yearStart || !this.formData.yearEnd) return;
            this.$emit('input', [
                this.formData.yearStart,
                moment(Number(this.formData.yearEnd))
                    .endOf('year')
                    .format('x'),
            ]);
            this.$emit('change', [
                this.formData.yearStart,
                moment(Number(this.formData.yearEnd))
                    .endOf('year')
                    .format('x'),
            ]);
        },
        onBlur() {
            if (!this.formData.yearEnd) this.formData.yearEnd = this.formData.yearStart;
            if (!this.formData.yearStart) this.formData.yearStart = this.formData.yearEnd;

            this.$emit('input', [
                this.formData.yearStart,
                moment(Number(this.formData.yearEnd))
                    .endOf('year')
                    .format('x'),
            ]);
            this.$emit('change', [
                this.formData.yearStart,
                moment(Number(this.formData.yearEnd))
                    .endOf('year')
                    .format('x'),
            ]);
        },
    },
};
</script>

<style lang="scss">
.ah-el-year-picker {

    min-width: 240px;

    >.picker-inner {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
        border-radius: 8px;
    }

    .el-input__inner {
        border: none;
        text-align: center;
    }
    .picker-first {
        width: 100%;
    }

    .line {
        text-align: center;
        color: #fff;
        opacity: 0.4;
    }

    .picker-second {
        width: 100%;
    }
}
</style>
